import React from "react";
import cx from "classnames";
import { Avatar } from "Components";

const MessageBubbleGroup = ({
  isIncomingMessage = true,
  isShowAvatar = true,
  avatarUrl = "/assets/icons/chat/ai.svg",
  wrapperCssClasses = "",
  children,
  isShowMeta = false,
  metaChildren,
}) => {

  return (
    <div
      className={cx("message-bubble-group", wrapperCssClasses, {
        "message-bubble-group--incoming": isIncomingMessage,
        "message-bubble-group--outgoing": !isIncomingMessage,
      })}
    >
      <div className="message-bubble-group-content">
        {isShowAvatar && <div className="message-bubble-group-avatar">
            <Avatar value={{ url: avatarUrl }} width="40px" />
          </div>}
        <div className="message-bubble-group-messages">
          {children}
        </div>
      </div>
      {isShowMeta && metaChildren}
    </div>
  )
};

// Memoize component to prevent unnecessary re-renders
export default React.memo(MessageBubbleGroup);
